<template>
  <div id="page-change-logs-view" class="mh-5">
    <vs-alert
      color="danger"
      :title="entity + ' Not Found'"
      :active.sync="not_found"
    >
      <span>Record with id: {{ $route.params.id }} not found.</span>
      <span>
        <span>Check </span>
        <router-link :to="listRoute" class="text-inherit underline">
          All {{ entity }}s
        </router-link>
      </span>
    </vs-alert>

    <vue-element-loading v-if="loading" :active="loading"/>


    <change-logs-form
      v-if="model"
      :value="model"
      :readonly="true"
      :is-latest="isLatest"
      :card-title="`Change Log: ${model.id}`"
      @back="goToList"
      @approve="approveChangeLog"
      @reject="rejectChangeLog"
    />
  </div>
</template>

<script>
import NotificationMixin from "@/components/mixins/NotificationMixin";
import ChangeLogsForm from './ChangeLogsForm';
import ViewModelMixin from '../../../../components/mixins/ViewModelMixin';
import CanAccessMixin from '../../../../components/mixins/CanAccessMixin';

export default {
  name: "ChangeLogsView",
  components: {
    ChangeLogsForm,
  },
  mixins: [NotificationMixin, ViewModelMixin, CanAccessMixin],
  data() {
    return {
      readonly: true,
      modelEntity: this.$api.facilities,
      baseRoute: 'facilities.change-logs',
      entity: 'Change Log',
      componentAccess: {
        canApprove: {
          route: 'facilities.edit',
          access: false
        },
        canReject: {
          route: 'facilities.edit',
          access: false
        }
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.changeLogId;
    },
    facilityId() {
      return this.$route.params.id;
    },
    listRoute() {
      return { name: this.baseRoute + '.list', params: { id: this.facilityId } };
    },
    isLatest() {
      // Check if this is the latest change log for the facility
      return !!(this.model && this.model.isLatest);
    },
    canApprove() {
      return this.componentAccess.canApprove.access && this.model && this.getStatus(this.model) === 'pending';
    },
    canReject() {
      return this.componentAccess.canReject.access && this.model && this.getStatus(this.model) === 'pending';
    }
  },
  async mounted() {
    await this.fetch(this.id);
  },
  methods: {
    goToList() {
      this.$router.push(this.listRoute);
    },
    async approveChangeLog() {
      try {
        await this.$api.facilities.approveChangeLog(this.facilityId, this.id);
        this.$vs.notify({
          color: 'success',
          title: 'Change Log Approved',
          text: 'Change log was successfully approved',
          position: 'top-right'
        });
        this.goToList();
      } catch (e) {
        console.error(e);
        this.$vs.notify({
          color: 'danger',
          title: 'Approval Failed',
          text: (e.response && e.response.data && e.response.data.message) || 'Failed to approve change log',
          position: 'top-right'
        });
      }
    },
    async rejectChangeLog() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Rejection',
        text: 'Are you sure you want to reject this change log?',
        accept: this.rejectAction,
        acceptText: 'Reject'
      });
    },
    async rejectAction() {
      try {
        await this.$api.facilities.rejectChangeLog(this.facilityId, this.id);
        this.$vs.notify({
          color: 'success',
          title: 'Change Log Rejected',
          text: 'Change log was successfully rejected',
          position: 'top-right'
        });
        this.goToList();
      } catch (e) {
        console.error(e);
        this.$vs.notify({
          color: 'danger',
          title: 'Rejection Failed',
          text: (e.response && e.response.data && e.response.data.message) || 'Failed to reject change log',
          position: 'top-right'
        });
      }
    },
    async fetch(id) {
      try {
        const response = await this.modelEntity.getChangeLog(this.facilityId, id);
        this.model = (response.data && response.data.data) || response.data;
      } catch (e) {
        console.error(e);
      } finally {
        if (!this.model) {
          this.not_found = true;
        }
      }
    },
    getStatus(changeLog) {
      if (changeLog.Approved) {
        return 'approved';
      }
      if (changeLog.Rejected) {
        return 'rejected';
      }
      return 'pending';
    },
  },
};
</script>

<style scoped>
</style>